import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { injectApiUrl } from '@seatix/shared-config';
import { map, Observable } from 'rxjs';
import { ApiResponse } from '@seatix/shared-domain-utils';
import { Order } from '@seatix/shared-domain-order';

@Injectable({
  providedIn: 'root',
})
export class CouponApiService {
  #http = inject(HttpClient);
  #apiUrl = `${injectApiUrl()}/api`;

  applyCoupon(
    orderId: number,
    code: string,
    referenceCode?: string,
  ): Observable<Order> {
    const body: Record<string, string> = { code };
    if (referenceCode) body['reference_code'] = referenceCode;
    return this.#http
      .post<
        ApiResponse<Order>
      >(`${this.#apiUrl}/orders/${orderId}/apply-coupon`, body)
      .pipe(map((r) => r.data));
  }

  removeCoupon(orderId: number): Observable<Order> {
    return this.#http
      .delete<
        ApiResponse<Order>
      >(`${this.#apiUrl}/orders/${orderId}/remove-coupon`)
      .pipe(map((r) => r.data));
  }
}
